export default __webpack_public_path__ + "static/media/2.7fd530a3.png";